import { InstitutionLanguage, InstitutionSubject } from "./types";

export const transformToLanguageObject = (
  language: InstitutionLanguage,
  institutionId: number,
  schoolYearId: number
) => ({
  id: language.id,
  institutionId,
  schoolYearId,
  languageId: language.id,
  languageName: language.name,
});

export const transformToSubjectObject = (
  subject: InstitutionSubject,
  institutionId: number,
  schoolYearId: number
) => ({
  id: subject.id,
  institutionId,
  schoolYearId,
  subjectId: subject.id,
  subjectName: subject.name,
});
